import {
  StyledBody,
  StyledContainer,
  StyledHalfImage,
  StyledSvgWrapper,
  StyledWrapper,
} from "components/general/stylingHero";
import asyncComponent from "components/split/asyncComponent";
import styled from "styled-components";
const SvgHero = asyncComponent(() => import("components/features/svgHero"));

const StyledCatSvg = styled(SvgHero)`
  height: 500px;
  width: 100%;
  @media screen and (max-width: 768px) {
    height: auto;
    width: 100%;
  }
`;

const Hero = () => {
  return (
    <StyledWrapper>
      <StyledContainer>
        <div className="hero__half">
          <h1 className="hero__title">Delete your Messages, Posts, DMs, and more</h1>
          <StyledBody>
            Redact lets you programatically delete your content from most major services. Bulk
            delete everything or set specific rules to follow based on data, keyword or more.
          </StyledBody>
        </div>
        <StyledHalfImage>
          <StyledSvgWrapper>
            <StyledCatSvg />
          </StyledSvgWrapper>
        </StyledHalfImage>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default Hero;
